// setTimeout(function() { 
//   document.addEventListener('DOMContentLoaded', function () {
//     //const subscribeBtn = document.getElementById('subscribe-button');
//     const subscribeBtn = document.querySelectorAll("div.u_content_form button");
//     if (subscribeBtn) {
//       subscribeBtn.addEventListener('click', function () {
        
//         // Fire the existing custom event (optional if already firing)
//         fbq('trackCustom', 'SubscribedButtonClick');
  
//         // Fire the standard Lead event
//         fbq('track', 'Lead');
//       });
//     }
//   });
// }, 4000);  

// setTimeout(function () {
//   document.addEventListener('DOMContentLoaded', function () {
//     const subscribeBtns = document.querySelectorAll("div.u_content_form button");

//     subscribeBtns.forEach(function (btn) {
//       btn.addEventListener('click', function () {
//         // Fire existing custom event
//         fbq('trackCustom', 'SubscribedButtonClick');

//         // Fire Meta's standard Lead event
//         fbq('track', 'Lead');

//         // Optional: log for debugging
//         console.log('Lead event fired');
//       });
//     });
//   });
// }, 4000);

$('body').on( 'click', 'div.u_content_form button', function () {
  fbq('trackCustom', 'SubscribedButtonClick');
  fbq('track', 'Lead');
  console.log('Lead event fired');
});


$('.multiple-items').slick({
  infinite: true,
  Padding: '60px',
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 2000,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

$( document ).ready(function() {
  $( 'body' ).on( 'click', '.disclosure--option', function () {
    setTimeout(function() {
      $('.product-buy-buttons--cta-text').text($('.product-price--original').text() + ' • ' + $('.product-buy-buttons--cta-text').parent().attr('data-text'));
    }, 800);
  });
  $( 'body' ).on( 'click', '.product-buy-buttons--primary', function () {
    setTimeout(function() {
      $(".product-buy-buttons--primary").addClass('test');
      $(".product-buy-buttons--primary").attr('aria-busy','false');
    }, 1000);  
  });  

  // $(window).scroll(function() {
  //   var wind_width = $( window ).width();
  //   var originalButton = $('.mob_stikcy');
    
  //   if(wind_width <= 767){  
  //     if ($(window).scrollTop() > originalButton.offset().top) {
  //       $('.sticky_buton').show();
  //     } else {
  //       $('.sticky_buton').hide();
  //     }
  //   }
  // });
  // $( 'body' ).on( 'click', '.sticky_buton .product-buy-buttons--primary', function () {
  //   $('.mob_stikcy').trigger('click');
  // });  
});





  